import { Component } from '@angular/core';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';

@Component( {
  selector: 'app-langmi-terms-page',
  templateUrl: './langmi-terms-page.component.html',
  styleUrls: [ './langmi-terms-page.component.scss' ]
} )
export class LangmiTermsPageComponent {

  URLS = URLS;

  environmentCommon = environmentCommon;

  constructor() {
    // Intentionally Blank
  }
}
